import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const UrgencySection = ({ onCtaClick }) => {
  return (
    <section className="py-20 bg-padua-olive text-padua-ivory shadow-inner">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }} 
          whileInView={{ opacity: 1, scale: 1 }} 
          viewport={{ once: true }} 
          className="flex flex-col md:flex-row items-center justify-between gap-12"
        >
          <div className="flex-1 text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-6 text-padua-gold">
              <SafeIcon name="Calendar" className="w-6 h-6" />
              <span className="uppercase tracking-[0.3em] text-xs font-bold">Limited Availability</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-serif text-padua-ivory mb-5">Now Touring for Upcoming Dates</h2>
            <p className="text-padua-ivory/80 text-lg leading-relaxed font-light">
              We recommend scheduling a tour early to secure your preferred date before availability changes.
            </p>
          </div>
          <div className="flex-shrink-0">
            <button 
              onClick={onCtaClick} 
              className="bg-padua-gold hover:bg-[#B5904D] text-padua-charcoal font-bold px-10 py-5 rounded-sm tracking-widest transition-all duration-300 shadow-2xl uppercase text-sm"
            >
              Check Availability
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UrgencySection;